var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.1371,
    cy: 31.1371,
    r: 31.1371,
    fill: "#AA1A19"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 38.3332C45 38.9763 44.8212 39.5724 44.5347 40.0969L35.3782 29.7344L44.4354 21.719C44.7878 22.2846 45 22.9489 45 23.6668V38.3332ZM30.5 31.6159L43.1028 20.462C42.5857 20.1756 42.0033 20 41.3751 20H19.625C18.996 20 18.4134 20.1756 17.8983 20.462L30.5 31.6159ZM34.0136 30.9411L31.0964 33.5246C30.9258 33.6749 30.7133 33.75 30.5 33.75C30.2867 33.75 30.0742 33.6749 29.9035 33.5246L26.9857 30.941L17.7134 41.436C18.2691 41.7887 18.9205 42 19.6249 42H41.3751C42.0794 42 42.731 41.7887 43.2866 41.436L34.0136 30.9411ZM16.5647 21.719C16.2124 22.2845 16 22.9489 16 23.6668V38.3333C16 38.9764 16.178 39.5725 16.4655 40.097L25.6209 29.7326L16.5647 21.719Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.b8b03689a1ef30d90c1d40950cb4008b.svg";
export { ForwardRef as ReactComponent };